// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy[data-v-402a2030] {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #409eff;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
